import { Inject, Injectable, Injector, NgZone, PLATFORM_ID } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { WindowRef } from '@spartacus/core'
import { isPlatformServer } from '@angular/common'
import { REQUEST } from '@nguniversal/express-engine/tokens'

@Injectable({ providedIn: 'root' })
export class CmsEnvironmentService {

  private readonly isFirstSpiritPreviewSubject = new BehaviorSubject<boolean>(false)
  readonly isFirstSpiritPreview$ = this.isFirstSpiritPreviewSubject.asObservable()

  isSSR = isPlatformServer(this.platformId)

  constructor (private ngZone: NgZone,
               protected winRef: WindowRef,
               protected injector: Injector,
               @Inject(PLATFORM_ID) protected platformId: any) {
    this.setIsFirstSpiritPreview()
  }

  private async setIsFirstSpiritPreview () {
    if (this.winRef.isBrowser()) {
      const TPP_SNAP = (await import('fs-tpp-api/snap') as any).default
      const isConnected = new BehaviorSubject(false)
      TPP_SNAP.onInit((success: boolean) => this.ngZone.run(() => {
        isConnected.next(success)
        this.isFirstSpiritPreviewSubject.next(success)
      }))
    }
  }

  sanitizeSsr (url: string) {
    if (this.isSSR && url.indexOf('http') !== 0) {
      const request = this.injector.get(REQUEST)
      const protocol = request.headers['x-forwarded-proto'] || request.protocol
      const host = request.headers['x-forwarded-host'] || request.headers['host'] || `${request.hostname}:${request.socket.localPort
      || (request.socket.address() as any).port}`
      return `${protocol}://${host}${url}`
    }
    return url
  }
}
